import { SchoolService, BaseService } from "@/services/school.service";

const CrewService = {
    getAll () {
        return SchoolService.getAll("crews")
    },

    add(payload) {
        return SchoolService.create("crews", payload)
    },

    update(object) {
        return SchoolService.update("crews", object.identifier, object)
    },

    delete(object) {
        return SchoolService.delete("crews", object.identifier, null)
    },

    // pupils

    getPupils(object) {
        return SchoolService.getAll("crews/" + object.identifier + "/pupils")
    },

    deletePupil(result, object) {
        return SchoolService.delete("crews/" + result.identifier + "/pupils", object.identifier, null) 
     },

     addPupil(payload) {
        return SchoolService.create("crews/pupils", payload)
    },
     
}

export { CrewService };